import request from "@/api";

export function listGroup(data) {
    return request({
        url: '/api/group/getGroupList',
        method: 'get',
        params: data
    })
}

export function saveGroup(data) {
    return request({
        url: '/api/group/saveGroup',
        method: 'post',
        data: data
    })
}

export function deleteGroup(data) {
    return request({
        url: '/api/group/deleteGroup',
        method: 'post',
        data: data
    })
}

export function listGroupUser(data) {
    return request({
        url: '/api/group/getGroupUserList',
        method: 'get',
        params: data
    })
}

export function saveGroupUser(data) {
    return request({
        url: '/api/group/saveGroupUser',
        method: 'post',
        data: data
    })
}

export function deleteGroupUser(data) {
    return request({
        url: '/api/group/deleteGroupUser',
        method: 'post',
        data: data
    })
}


export function listGroupPermissionName(data) {
    return request({
        url: '/api/group/getGroupPermissionNameList',
        method: 'get',
        params: data
    })
}

export function listGroupPermissionId(data) {
    return request({
        url: '/api/group/getGroupPermissionIdList',
        method: 'get',
        params: data
    })
}

export function saveGroupPermission(data) {
    return request({
        url: '/api/group/saveGroupPermission',
        method: 'post',
        data: data
    })
}

